import { IconButton, darken, lighten, styled, Button } from '@mui/material';

import { getOppositeColor } from '/helpers';
import { arrowRotation } from '/styles';
import { styledCustom } from '/styles/helpers';

import { ITagsSelectProps } from '../../types';

export const TagWrapper = styledCustom('div')<{
  $mainColor: ITagsSelectProps['mainColor'];
  $selected?: ITagsSelectProps['selected'];
}>`
  --borderRadius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border:  0;
  height: fit-content;
  cursor: ${({ $selected }) => ($selected ? 'default' : 'pointer')};
  border-radius: var(--borderRadius);
  opacity: ${({ $selected }) => ($selected ? 0.7 : 1)};
  background-color: ${({ theme, $mainColor }) => (theme.palette.mode === 'light' ? $mainColor.backgroundColor : ($mainColor.backgroundColorDark ?? $mainColor.backgroundColor))};
    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
  color: ${({ theme, $mainColor }) => ($mainColor.color ? $mainColor.color : getOppositeColor(theme.palette.warning.main))};
  & svg {
    ${arrowRotation}
  }

  p,
  button:last-of-type {
    color: ${({ theme, $mainColor }) => {
      const color = theme.palette.mode === 'light' ? $mainColor.color : $mainColor.colorDark;
      return color ?? getOppositeColor(theme.palette.warning.main);
    }};
  }

${({ $selected, theme, $mainColor }) =>
  !$selected &&
  `
    button:hover {
      background-color: ${
        theme.palette.mode === 'light'
          ? darken($mainColor.backgroundColor, 0.1)
          : lighten($mainColor.backgroundColor, 0.1)
      }`};
`;

export const SelectIconButton = styled(IconButton)`
  height: -moz-available;
  height: stretch;
  padding: 0;
  padding-right: 4px;
  border-radius: 0 var(--borderRadius) var(--borderRadius) 0;
`;
export const SelectButton = styledCustom(Button)<{ $isSelectable: ITagsSelectProps['isSelectable'] }>`
  min-width: 0;
  padding: 2px 6px 2px 8px;
  width: fit-content;
  text-transform: none;
  border-radius: ${({ $isSelectable }) => ($isSelectable ? 'inherit' : 'var(--borderRadius) 0 0 var(--borderRadius)')};
  & .MuiButton-endIcon {
    margin-left: 0;
  }
`;
